/* ==========================================================================
   nb-wishlist.js — Nuttet Baby ønskeliste (localStorage, ingen app, ingen konto)

   Porteret fra design/wishlist.js, men gemmer PRODUCT HANDLES i stedet for
   prototypens id'er, saa listen kan slaas op i Shopify.

   Lager:   localStorage 'nb_wishlist_v1'  → ["kostume-loeve", "plakat-abc"]
   Event:   'nb-wishlist-updated' (window + document)
            detail: { handles, count, handle, added }
            'nb-wishlist-open' udsendes naar et produkt tilfoejes (prototypens
            adfaerd — en evt. drawer kan lytte med).

   Offentligt API (window.NBWishlist):
     inWishlist(handle) → boolean
     toggle(handle)     → boolean (true = nu paa listen)
     add(handle)        → boolean
     remove(handle)     → boolean
     count()            → number
     all()              → string[]  (nyeste foerst)
     clear()            → void

   DOM-kroge (al tekst kommer fra Liquid — INTET dansk i denne fil):
     [data-nb-wishlist="<handle>"]   toggle-knap. Faar aria-pressed,
                                     .is-active og aria-label fra
                                     data-nb-label-add / data-nb-label-remove.
     [data-nb-wishlist-count]        badge: textContent = antal, skjules ved 0.
     [data-nb-wishlist-total]        tekst-taeller: bruger data-nb-label med
                                     {count}-token, skjules aldrig.
     [data-nb-wishlist-page]         ønskelistesiden (se afsnit 4).

   Idempotent: filen kan indlaeses to gange, og alt re-synkroniseres paa
   'shopify:section:load' samt paa 'storage' (andre faner).
   ========================================================================== */
(function () {
  'use strict';

  if (window.NBWishlist && window.NBWishlist.__nb) return;

  var KEY = 'nb_wishlist_v1';

  /* ======================================================================
     1) Lager
     ====================================================================== */

  function read() {
    var raw;
    try {
      raw = window.localStorage.getItem(KEY);
    } catch (e) {
      return [];
    }
    if (!raw) return [];

    var parsed;
    try {
      parsed = JSON.parse(raw);
    } catch (e) {
      return [];
    }
    if (!Array.isArray(parsed)) return [];

    var out = [];
    for (var i = 0; i < parsed.length; i++) {
      var item = parsed[i];
      /* Tolerér prototypens gamle objektform {id, handle, …}. */
      var handle = typeof item === 'string' ? item : item && (item.handle || item.id);
      if (typeof handle !== 'string') continue;
      handle = handle.trim();
      if (!handle || out.indexOf(handle) !== -1) continue;
      out.push(handle);
    }
    return out;
  }

  function write(handles) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(handles));
    } catch (e) {
      /* private mode: listen lever kun i denne session */
    }
  }

  function publish(detail) {
    var payload = detail || {};
    payload.handles = read();
    payload.count = payload.handles.length;
    syncDom();
    dispatch('nb-wishlist-updated', payload);
  }

  function dispatch(name, detail) {
    var event;
    try {
      event = new CustomEvent(name, { detail: detail, bubbles: true });
    } catch (e) {
      return;
    }
    window.dispatchEvent(event);
    try {
      document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true }));
    } catch (e) {
      /* ignoreres */
    }
  }

  /* ======================================================================
     2) API
     ====================================================================== */

  function inWishlist(handle) {
    if (!handle) return false;
    return read().indexOf(String(handle)) !== -1;
  }

  function add(handle) {
    if (!handle) return false;
    var key = String(handle);
    var handles = read();
    if (handles.indexOf(key) !== -1) return false;
    handles.push(key);
    write(handles);
    publish({ handle: key, added: true });
    dispatch('nb-wishlist-open', { handle: key });
    return true;
  }

  function remove(handle) {
    if (!handle) return false;
    var key = String(handle);
    var handles = read();
    var idx = handles.indexOf(key);
    if (idx === -1) return false;
    handles.splice(idx, 1);
    write(handles);
    publish({ handle: key, added: false });
    return true;
  }

  function toggle(handle) {
    if (!handle) return false;
    if (inWishlist(handle)) {
      remove(handle);
      return false;
    }
    add(handle);
    return true;
  }

  function count() {
    return read().length;
  }

  /* Nyeste foerst — det er den raekkefoelge oenskelistesiden vises i. */
  function all() {
    return read().slice().reverse();
  }

  function clear() {
    write([]);
    publish({ handle: null, added: false });
  }

  /* ======================================================================
     3) DOM-synkronisering
     ====================================================================== */

  function syncButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var buttons = scope.querySelectorAll('[data-nb-wishlist]');
    var handles = read();

    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var handle = button.getAttribute('data-nb-wishlist');
      if (!handle) continue;

      var active = handles.indexOf(handle) !== -1;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.classList.toggle('is-active', active);

      var label = button.getAttribute(active ? 'data-nb-label-remove' : 'data-nb-label-add');
      if (label) {
        button.setAttribute('aria-label', label);
        if (button.hasAttribute('title')) button.setAttribute('title', label);
      }

      /* Fyldt vs. outline hjerte styres primaert af CSS
         ([aria-pressed="true"] .nb-card__heart { fill: currentColor }).
         Her sikres det ogsaa for ikoner uden den regel. */
      var icon = button.querySelector('[data-nb-heart], svg');
      if (icon) icon.classList.toggle('is-filled', active);
    }
  }

  function syncCounters(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var total = count();

    var badges = scope.querySelectorAll('[data-nb-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = String(total);
      badges[i].hidden = total === 0;
    }

    var totals = scope.querySelectorAll('[data-nb-wishlist-total]');
    for (var j = 0; j < totals.length; j++) {
      var el = totals[j];
      var template = el.getAttribute('data-nb-label');
      el.textContent = template ? template.replace(/\{count\}/g, String(total)) : String(total);
    }
  }

  function syncDom(root) {
    syncButtons(root);
    syncCounters(root);
    renderPages(root);
  }

  /* Én delegeret klik-lytter — daekker ogsaa kort der bliver indsat senere. */
  function onClick(event) {
    var origin = event.target;
    if (!origin || typeof origin.closest !== 'function') return;
    var target = origin.closest('[data-nb-wishlist]');
    if (!target) return;
    var handle = target.getAttribute('data-nb-wishlist');
    if (!handle) return;
    event.preventDefault();
    toggle(handle);
  }

  /* ======================================================================
     4) Ønskelistesiden
     ----------------------------------------------------------------------
     Siden renderes klientside ud fra de gemte handles. Al markup og tekst
     kommer fra en <template> i Liquid — denne fil udfylder kun felterne.

       <div data-nb-wishlist-page
            data-nb-money-format="{{ shop.money_format }}">
         <template data-nb-wishlist-card>
           <article class="nb-card" data-nb-bind="card">
             <a data-nb-bind="url"><img data-nb-bind="image" alt=""></a>
             <button data-nb-bind="wishlist"
                     data-nb-label-add="…" data-nb-label-remove="…">…</button>
             <a data-nb-bind="url" data-nb-bind-text="title"></a>
             <span data-nb-bind="price"></span>
             <s data-nb-bind="compare"></s>
             <span data-nb-bind="save" data-nb-label="Spar {percent} %"></span>
             <span data-nb-bind="soldout">Udsolgt</span>
             <a class="nb-card__add" data-nb-bind="url">Se produkt</a>
           </article>
         </template>
         <div data-nb-wishlist-grid></div>
         <div data-nb-wishlist-loading hidden>…</div>
         <div data-nb-wishlist-empty hidden>… tom-state …</div>
         <div data-nb-wishlist-error hidden>…</div>
       </div>

     Bindinger (data-nb-bind):
       card      rod-elementet, faar data-nb-handle
       url       <a> → href (ellers data-href)
       image     <img> → src/srcset/sizes/alt
       title     textContent (eller data-nb-bind-text="title" paa url-linket)
       price     formateret pris
       compare   foerpris — elementet skjules hvis der ikke er en
       save      rabatprocent via data-nb-label med {percent}
       soldout   vises kun naar produktet er udsolgt
       available vises kun naar produktet er paa lager
       wishlist  faar data-nb-wishlist="<handle>" (fjern-knappen)

     Produktdata hentes med GET /products/<handle>.js. Findes et produkt
     ikke laengere (404), fjernes handlet stille fra listen.
     ====================================================================== */

  var productCache = {};
  var pageState = typeof WeakMap === 'function' ? new WeakMap() : null;
  var pageFallback = [];

  function stateFor(page) {
    if (pageState) {
      var found = pageState.get(page);
      if (!found) {
        found = { rendered: null, token: 0 };
        pageState.set(page, found);
      }
      return found;
    }
    for (var i = 0; i < pageFallback.length; i++) {
      if (pageFallback[i].el === page) return pageFallback[i].state;
    }
    var entry = { el: page, state: { rendered: null, token: 0 } };
    pageFallback.push(entry);
    return entry.state;
  }

  function routeRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (!root) return '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch(routeRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (response.status === 404) return null;
        if (!response.ok) throw new Error('nb-wishlist: ' + response.status);
        return response.json();
      })
      .catch(function (error) {
        delete productCache[handle];
        throw error;
      });
    return productCache[handle];
  }

  /* Shopify money_format-tokens. Falder tilbage til Intl. */
  function formatMoney(cents, format) {
    var amount = (Number(cents) || 0) / 100;

    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
        switch (token) {
          case 'amount':
            return group(amount, 2, ',', '.');
          case 'amount_no_decimals':
            return group(Math.round(amount), 0, ',', '.');
          case 'amount_with_comma_separator':
            return group(amount, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator':
            return group(Math.round(amount), 0, '.', ',');
          case 'amount_with_space_separator':
            return group(amount, 2, ' ', ',');
          case 'amount_no_decimals_with_space_separator':
            return group(Math.round(amount), 0, ' ', ',');
          case 'amount_with_apostrophe_separator':
            return group(amount, 2, "'", '.');
          default:
            return group(amount, 2, '.', ',');
        }
      });
    }

    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'DKK';
    var locale = document.documentElement.getAttribute('lang') || 'da-DK';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function group(value, decimals, thousands, decimalMark) {
    var fixed = Math.abs(value).toFixed(decimals);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var rest = parts[1] ? decimalMark + parts[1] : '';
    return (value < 0 ? '-' : '') + whole + rest;
  }

  function cdnUrl(src, width) {
    if (!src) return '';
    var url = src.indexOf('//') === 0 ? window.location.protocol + src : src;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function bindCard(node, product, page) {
    var moneyFormat = page.getAttribute('data-nb-money-format') || '';
    var onSale = product.compare_at_price && product.compare_at_price > product.price;
    var savePct = onSale
      ? Math.round(((product.compare_at_price - product.price) * 100) / product.compare_at_price)
      : 0;

    var targets = node.querySelectorAll('[data-nb-bind]');
    var list = [];
    if (node.hasAttribute && node.hasAttribute('data-nb-bind')) list.push(node);
    for (var i = 0; i < targets.length; i++) list.push(targets[i]);

    for (var j = 0; j < list.length; j++) {
      var el = list[j];
      var bind = el.getAttribute('data-nb-bind');

      switch (bind) {
        case 'card':
          el.setAttribute('data-nb-handle', product.handle);
          break;

        case 'url':
          if (el.tagName === 'A') el.setAttribute('href', product.url);
          else el.setAttribute('data-href', product.url);
          if (el.getAttribute('data-nb-bind-text') === 'title') el.textContent = product.title;
          break;

        case 'image':
          if (product.featured_image) {
            el.setAttribute('src', cdnUrl(product.featured_image, 600));
            el.setAttribute(
              'srcset',
              cdnUrl(product.featured_image, 300) + ' 300w, ' + cdnUrl(product.featured_image, 600) + ' 600w'
            );
            if (!el.getAttribute('sizes')) el.setAttribute('sizes', '(max-width: 640px) 45vw, 240px');
            el.setAttribute('loading', 'lazy');
            el.setAttribute('decoding', 'async');
            el.setAttribute('alt', product.title);
          } else {
            el.removeAttribute('src');
            el.hidden = true;
          }
          break;

        case 'title':
          el.textContent = product.title;
          break;

        case 'price':
          el.textContent = formatMoney(product.price, moneyFormat);
          break;

        case 'compare':
          if (onSale) {
            el.textContent = formatMoney(product.compare_at_price, moneyFormat);
            el.hidden = false;
          } else {
            el.textContent = '';
            el.hidden = true;
          }
          break;

        case 'save':
          if (onSale) {
            var template = el.getAttribute('data-nb-label') || '{percent}';
            el.textContent = template.replace(/\{percent\}/g, String(savePct));
            el.hidden = false;
          } else {
            el.hidden = true;
          }
          break;

        case 'soldout':
          el.hidden = !!product.available;
          break;

        case 'available':
          el.hidden = !product.available;
          break;

        case 'wishlist':
          el.setAttribute('data-nb-wishlist', product.handle);
          el.setAttribute('aria-pressed', 'true');
          break;

        default:
          break;
      }
    }

    return node;
  }

  function setHidden(page, selector, hidden) {
    var el = page.querySelector(selector);
    if (el) el.hidden = hidden;
  }

  function renderPage(page) {
    var template = page.querySelector('template[data-nb-wishlist-card]');
    var grid = page.querySelector('[data-nb-wishlist-grid]');
    var handles = all();
    var state = stateFor(page);
    var signature = handles.join('|');

    /* Uden template kan siden kun vise tom/ikke-tom-tilstand. */
    if (!template || !grid) {
      setHidden(page, '[data-nb-wishlist-empty]', handles.length > 0);
      page.classList.toggle('is-empty', handles.length === 0);
      return;
    }

    if (state.rendered === signature) return;
    state.rendered = signature;

    page.classList.toggle('is-empty', handles.length === 0);
    setHidden(page, '[data-nb-wishlist-error]', true);

    if (!handles.length) {
      grid.textContent = '';
      setHidden(page, '[data-nb-wishlist-loading]', true);
      setHidden(page, '[data-nb-wishlist-empty]', false);
      return;
    }

    setHidden(page, '[data-nb-wishlist-empty]', true);
    setHidden(page, '[data-nb-wishlist-loading]', false);

    var token = ++state.token;

    Promise.all(
      handles.map(function (handle) {
        return fetchProduct(handle).then(
          function (product) {
            return { handle: handle, product: product };
          },
          function () {
            return { handle: handle, product: undefined };
          }
        );
      })
    ).then(function (results) {
      if (token !== state.token) return; /* nyere render har overhalet denne */

      var fragment = document.createDocumentFragment();
      var missing = [];
      var failed = 0;

      results.forEach(function (result) {
        if (result.product === null) {
          missing.push(result.handle);
          return;
        }
        if (!result.product) {
          failed++;
          return;
        }
        var node = template.content.firstElementChild;
        if (!node) return;
        fragment.appendChild(bindCard(node.cloneNode(true), result.product, page));
      });

      grid.textContent = '';
      grid.appendChild(fragment);

      setHidden(page, '[data-nb-wishlist-loading]', true);
      setHidden(page, '[data-nb-wishlist-error]', failed === 0);

      syncButtons(grid);

      /* Slettede produkter ryddes stille ud af listen. */
      if (missing.length) {
        var handlesNow = read().filter(function (handle) {
          return missing.indexOf(handle) === -1;
        });
        write(handlesNow);
        state.rendered = null;
        publish({ handle: null, added: false });
      } else if (!grid.children.length) {
        setHidden(page, '[data-nb-wishlist-empty]', false);
      }
    });
  }

  function renderPages(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var pages = scope.querySelectorAll('[data-nb-wishlist-page]');
    for (var i = 0; i < pages.length; i++) renderPage(pages[i]);
    if (root && root.matches && root.matches('[data-nb-wishlist-page]')) renderPage(root);
  }

  /* ======================================================================
     5) Init — idempotent
     ====================================================================== */

  function init(root) {
    syncDom(root);
  }

  if (!window.__nbWishlistBound) {
    window.__nbWishlistBound = true;

    document.addEventListener('click', onClick);

    /* Andre faner / vinduer. */
    window.addEventListener('storage', function (event) {
      if (event.key && event.key !== KEY) return;
      syncDom();
    });

    /* Section Rendering API re-renderer DOM — synkronisér den nye sektion. */
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target || document);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init(document);
      });
    } else {
      init(document);
    }
  } else {
    init(document);
  }

  /* ======================================================================
     6) Eksport
     ====================================================================== */

  window.NBWishlist = {
    __nb: true,
    key: KEY,
    inWishlist: inWishlist,
    toggle: toggle,
    add: add,
    remove: remove,
    count: count,
    all: all,
    clear: clear,
    sync: init
  };
})();
